
export enum BudgetStatus {
    IN_STUDY = 'IN_STUDY',
    ON_HOLD = 'ON_HOLD',
    ACCEPTED = 'ACCEPTED',
    REFUSED = 'REFUSED',
}
